/* Scene slider — StoreFrontOlden.
   Vanilla, no dependencies. Autoplays on the interval set in the theme
   editor; pauses on hover, on keyboard focus and while the tab is hidden.
   Arrows, dots, left/right keys and swipe move it by hand and restart the
   clock. No autoplay with prefers-reduced-motion. Once the page has
   loaded, the other photos are fetched in the background so a change of
   picture never waits for an image. */
(function () {
  function init(root) {
    if (!root || root.zvoScenesReady) return;
    root.zvoScenesReady = true;

    var stage = root.querySelector('[data-zvo-stage]');
    var slides = [].slice.call(root.querySelectorAll('[data-zvo-slide]'));
    if (!stage || slides.length < 2) return;

    var dots = [].slice.call(root.querySelectorAll('[data-zvo-dot]'));
    var live = root.querySelector('[data-zvo-live]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 8000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var index = 0;
    var timer = null;
    var held = false;

    function preload() {
      [].slice.call(root.querySelectorAll('.zvo-scenes__photo img[loading="lazy"]')).forEach(function (img) {
        img.loading = 'eager';
      });
    }
    if (document.readyState === 'complete') setTimeout(preload, 300);
    else window.addEventListener('load', function () { setTimeout(preload, 300); });

    function show(next) {
      index = (next % slides.length + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (live) live.textContent = 'Picture ' + (index + 1) + ' of ' + slides.length;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      root.classList.remove('zvo-scenes--playing');
    }

    function play() {
      stop();
      if (reduced || held || document.hidden) return;
      root.classList.add('zvo-scenes--playing');
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    function go(next) { show(next); play(); }

    var prev = root.querySelector('[data-zvo-prev]');
    var next = root.querySelector('[data-zvo-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    function hold() { held = true; stop(); }
    function release() { held = false; play(); }
    root.addEventListener('mouseenter', hold);
    root.addEventListener('mouseleave', release);
    root.addEventListener('focusin', hold);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) release();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });

    var startX = null;
    stage.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    show(0);
    play();
  }

  function initAll(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    [].slice.call(host.querySelectorAll('[data-zvo-scenes]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
